<div class="d-flex base-border toggle-tabs-menu c-bg-gray-100 medium-border-radius">
  @for (option of options; track option; let i = $index) {
    <div
      [class.disabled]="disabledIndexes | arrayIncludes:i"
      [class.d-none]="hiddenIndexes | arrayIncludes:i"
      class="toggle-tabs-menu__item p3 cursor-pointer text-center p-12 flex-grow-1"
      [class.selected]="i === selectedIndex"
      (click)="!allowDeselect ? selectedIndex = i : i === selectedIndex ? selectedIndex = null : selectedIndex = i; selectedIndexChange.emit(selectedIndex)"
    >
      {{ option }}
    </div>
  }
</div>
